import { ExpansionPanel } from '@material-ui/core';

const PartnersActionTypes = {
  SET_PARTNERS: 'SET_PARTNERS',
};

export default PartnersActionTypes;
